import React, { lazy, Suspense } from 'react';
import type { DynamicTableV2Props } from '../types/DynamicTableV2.types';

const LegacyDynamicTable = lazy(() => import('../../components/Table'));

export function V1RendererBridge(props: DynamicTableV2Props): JSX.Element {
  const {
    schema,
    data,
    loading = 'idle',
    totalCount = 0,
    onSave,
    isSaveLoading,
    selectedKeys,
    onSelectionChange,
    containerClassName,
    filter,
    selectedColumnList,
    onColumnPreferenceChange,
    tablePreferenceLoading,
    onLoadMore,
    loadMoreStatus,
  } = props;

  return (
    <Suspense
      fallback={
        <div data-testid='dt-v2-v1-fallback' className='dt-v2-v1-fallback'>
          Loading table…
        </div>
      }>
      <LegacyDynamicTable
        {...({
          schema,
          data: data ?? [],
          loading,
          totalCounts: totalCount,
          containerClassName,
          checkedValues: selectedKeys,
          onChecked: onSelectionChange,
          filter,
          selectedColumnList,
          handleColumnSave: onColumnPreferenceChange,
          tablePreferenceLoading,
          onSave,
          isSaveLoading,
          onLoadMore,
          loadMoreStatus,
        } as any)}
      />
    </Suspense>
  );
}
